import { render, staticRenderFns } from "./MemberDocs.vue?vue&type=template&id=4fe02b6e"
import script from "./MemberDocs.vue?vue&type=script&lang=js"
export * from "./MemberDocs.vue?vue&type=script&lang=js"
import style0 from "./MemberDocs.vue?vue&type=style&index=0&id=4fe02b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports